import { createContext, useContext, useState } from "react";
import { callGetApi } from "./api/ApiCaller";
import { BASE_URL_PLAYER, GET_PLAYER_BALANCE_GET } from "./api/ApiConst";
import { STATUS } from "./utils/Constants";
import toast from "react-hot-toast";

export const BalanceContext = createContext();

export const BalanceProvider = ({ children }) => {
    const [profileDetails, setProfileDetails] = useState();
    const [walletBalance, setWalletBalance] = useState(null);
    const [hiddenBalance, setHiddenBalance] = useState(false);
    const getWalletBalance = () => {
        callGetApi(GET_PLAYER_BALANCE_GET, {}, (response) => {
            if (response.errorCode === 0) {
                const balance = Math.round(response.responsePacket * 100.0) / 100.0;
                setWalletBalance(balance);
            }
        });
    };

    const getPlayerDetails = () => {
        callGetApi(BASE_URL_PLAYER, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                let res = response.responsePacket;
                setProfileDetails(res);
            } else {
                toast.error(response.message);
            }
        },
            (e) => {
                toast.error(e.message);
            }
        );
    }
  return (
    <BalanceContext.Provider value={{ profileDetails, walletBalance, getPlayerDetails, getWalletBalance, hiddenBalance, setHiddenBalance }}>
        {children}
    </BalanceContext.Provider>
  )
}

export  const useBalance = () => {
    const context = useContext(BalanceContext);
    if (!context) {
        throw new Error("useBalance must be used within a BalanceProvider");
    }
    return context;
}